import * as React from "react";

import { Video } from "../../types";
import { Info, Space, TextInput } from "../../styled-component";
import VideoService from "../../services/Video";
import CRUDModal, { CRUDModalProps } from "../../common/components/CRUDModal";

import Text from "../common/Text";
import Layout from "../common/Layout";

import VideoPreview from "./VideoPreview";

const DEFAULT_VALUES = { url: "", name: "" };

export type CreateOrUpdateVideoProps = Omit<CRUDModalProps<Video>, "service">;

const service = new VideoService();

function CreateOrUpdateVideo({ ...rest }: CreateOrUpdateVideoProps) {
  const getButtonTitle: CRUDModalProps<Video>["getButtonTitle"] = (
    _video,
    { isNew } = {}
  ) => (isNew ? "Create Video" : "Edit Video");

  const getModalTitle: CRUDModalProps<Video>["getModalTitle"] = (
    video,
    { isNew } = {}
  ) => (isNew ? "New Video" : video?.name || video?.url || "|");

  const getDefaultValues: CRUDModalProps<Video>["getDefaultValues"] = (video) =>
    video || DEFAULT_VALUES;

  return (
    <CRUDModal<Video>
      {...rest}
      getButtonTitle={getButtonTitle}
      getModalTitle={getModalTitle}
      getDefaultValues={getDefaultValues}
      service={service}
      renderForm={({ setValue, watch, isNew, isDisabled }) => {
        const name = watch("name");
        const url = watch("url");

        return (
          <>
            <Text.Label>Name</Text.Label>
            <TextInput
              autoFocus={isNew}
              editable={!isDisabled}
              onChangeText={(nextName) => setValue("name", nextName)}
              value={name}
            />

            <Space />

            <Text.Label>Url</Text.Label>
            <TextInput
              editable={!isDisabled}
              onChangeText={(nextUrl) => setValue("url", nextUrl)}
              placeholder="https://vimeo.com/226053498"
              value={url}
            />

            <Space />

            <Text.Label>Preview</Text.Label>
            <Info alignItems="center" size={1}>
              <VideoPreview url={url} />
            </Info>
          </>
        );
      }}
    />
  );
}

export default CreateOrUpdateVideo;
